import { Dispatch } from '../../common/state';
import { setTermValue } from './advanced/term';

export function changeHasVideo(value: boolean | undefined) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('has_video', value || undefined));
  };
}
